import _ from 'lodash';

function ensure(m) {
    return m.default ? m.default : m;
}

export default (Vue, projectName, account, opt = {}, locale, isFreeView = false) => {
    const sentry = opt.sentry;
    if (process.env.NODE_ENV !== 'production') {
        console.info('%c开发环境禁用第三方工具', 'color: red');
        return;
    }

    setTimeout(() => {
        if (!sentry) return;
        import('../services/sentry')
            .then(ensure)
            .then(async sentryApp => {
                await sentryApp(Vue, projectName, account.thirdParty.sentry);
                import('../utils/browser-checker')
                    .then(ensure)
                    .then(checker => checker(account, locale));
            });
    }, 3 * 1000);

    setTimeout(() => {
        import('../services/third-party').then(ensure).then(loadThirdParty => {
            loadThirdParty(account.thirdParty, locale, isFreeView);
        });
    }, 10 * 1000);

    setTimeout(() => {
        if (_.isObject(window.newrelic)) {
            window.newrelic.addPageAction('init', {
                uid: _.get(account, '_info.account_id', ''),
                cid: _.get(account, '_info.company_id', ''),
            });
        }
    }, 3 * 1000);
};


export function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
